import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, Home, Calendar, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

export default function ThankYouPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-secondary via-white to-secondary/50 flex items-center justify-center py-12 px-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl w-full"
      >
        <div className="glass-card bg-white/95 shadow-2xl text-center">
          {/* Success Icon */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-8"
          >
            <CheckCircle className="text-primary" size={48} />
          </motion.div>

          <h1 className="font-outfit font-bold text-3xl md:text-4xl text-text-primary mb-4">
            Merci pour votre confiance !
          </h1>

          <p className="font-manrope text-text-secondary text-lg mb-8 max-w-lg mx-auto">
            Votre demande a bien été enregistrée. Vous allez recevoir un rapport estimatif détaillé 
            de votre projet de rénovation énergétique par e-mail dans les plus brefs délais.
          </p>

          <div className="bg-secondary/50 rounded-2xl p-6 mb-8">
            <p className="font-manrope text-text-secondary text-sm">
              Notre équipe d'experts reste à votre disposition pour toute question. 
              N'hésitez pas à nous contacter pour un accompagnement personnalisé.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button 
                variant="outline"
                className="btn-secondary w-full sm:w-auto"
                data-testid="btn-retour-accueil"
              >
                <Home size={18} className="mr-2" />
                Retour à l'accueil
              </Button>
            </Link>
            <Link to="/tarifs">
              <Button 
                className="btn-primary w-full sm:w-auto"
                data-testid="btn-voir-offres"
              >
                <Calendar size={18} className="mr-2" />
                Voir nos offres
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </Link>
          </div>

          {/* Additional Info */}
          <div className="mt-10 pt-8 border-t border-gray-100">
            <h3 className="font-outfit font-semibold text-text-primary mb-4">
              Prochaines étapes
            </h3>
            <div className="grid md:grid-cols-3 gap-4">
              {[
                { step: "1", title: "Analyse", desc: "Étude de votre dossier" },
                { step: "2", title: "Contact", desc: "Appel d'un expert" },
                { step: "3", title: "Proposition", desc: "Solutions personnalisées" }
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 + index * 0.1 }}
                  className="p-4 bg-gray-50 rounded-xl"
                >
                  <div className="w-8 h-8 rounded-full bg-primary text-white font-outfit font-bold text-sm flex items-center justify-center mx-auto mb-2">
                    {item.step}
                  </div>
                  <h4 className="font-outfit font-semibold text-text-primary text-sm">
                    {item.title}
                  </h4>
                  <p className="text-xs text-text-muted font-manrope">{item.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
